<template lang="pug">
	div.mt-2
		table.table.table-striped(v-if="resultados.length > 0")
			thead.bg-dark.text-white
				tr
					th ID
					th Agente
					th Cliente
					th Contrato
					th
		
		.alert.alert-warning.text-center(v-else)
			h1 No hay resultados
</template>

<script>
export default {
	props: ['resultados']
}
</script>



// WEBPACK FOOTER //
// src/modulos/radiacion/vue/components/listado/resultados.vue